var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-left flex flex-row items-center max-w-2xs mt-4 px-6 py-4 mx-auto border rounded-sm shadow",class:{
    'bg-white border-grey-lighter dark:bg-black dark:border-grey-dark': _vm.success,
    'text-white bg-red border border-red': !_vm.success,
  }},[(_vm.loading)?_c('span',{staticClass:"flex-none inline-flex items-center w-8 h-8"},[_c('UnraidLoading',{attrs:{"height":18}})],1):_c('span',{staticClass:"text-2xl font-semibold inline-flex items-center justify-center rounded-full w-8 h-8 p-2",class:{
      'text-white bg-gradient-to-r from-red to-orange': _vm.success,
      'text-red bg-white': !_vm.success },domProps:{"innerHTML":_vm._s(_vm.icon)}}),_c('span',{staticClass:"ml-4"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }